import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=3aec23d1&scoped=true&"
import script from "./categories.vue?vue&type=script&lang=js&"
export * from "./categories.vue?vue&type=script&lang=js&"
import style0 from "./categories.vue?vue&type=style&index=0&id=3aec23d1&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./categories.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aec23d1",
  null
  
)

export default component.exports